import React from 'react';
import { Link } from 'react-router-dom';

const OrderPlaced = () => {
  return (
    <div>
        <div className='text-white'>.</div>
      <div className="bg-gray-100 shadow-lg rounded-lg p-8 md:p-16 text-center mt-16 font-twentieth-century">
        <div className="flex justify-center mb-8">
          <svg
            width="60"
            height="60"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-32 h-32 md:w-48 md:h-48 text-green-500"
          >
            <circle cx="60" cy="60" r="60" fill="#4CAF50" />
            <path
              d="M30 60L50 80L90 40"
              stroke="white"
              strokeWidth="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h1 className="text-2xl md:text-4xl font-bold text-gray-800 mb-4">
          Order Placed Successfully!
        </h1>
        <p className="mt-4 text-lg text-gray-600">
          Thank you for your willful purchase Your order will be delivered soon
        </p>
        <Link
          to="/orders"
          className="mt-8 inline-block px-6 py-3 bg-red-600 text-white font-semibold rounded-md shadow-md hover:bg-red-700 transition duration-300"
        >
          View Orders
        </Link>
      </div>
    </div>
  );
};

export default OrderPlaced;
